import {NeoAGgrid} from "@/components/table/neo-table/neo-ag-grid";
import {useEffect, useState} from "react";

const tableConfig = {
  columns: [],
  activeColumns: ["name"],
  activeFilters: [],
  style: {
    height: "h-full"
  },
  rowSelection: false,
  meta: {
    id: 0,
    title: "",
    description: "Total Data",
    hasSearch: false,
    hasUpload: false,
    hasDownload: true,
    hasAdd: false,
    hasActions: false,
    hasCheckbox: false,
    hasFilter: false,
    hasFooter: true,
    hasHeader: true,
    hasPagination: true,
    hasCreate: false
  },
  url: {
    page: {},
    api: {}
  },
  actions: [],
  tabledatas: []
};
const mappedColumns = [
  {uid: "name", name: "Name", checkbox: false},
  {uid: "admissionNo", name: "Admission No", checkbox: false},
  {uid: "vehicleName", name: "Vehicle", checkbox: false},
  {uid: "routeName", name: "Route", checkbox: false},
  {uid: "bpLat", name: "Latitude", checkbox: false},
  {uid: "bpLng", name: "Longitude ", checkbox: false},
  {uid: "bpName", name: "Stop", checkbox: false}
];

const unmappedColumns = [
  {uid: "admissionNo", name: "admissionNo", checkbox: false},
  {uid: "name", name: "name", checkbox: false},
  {uid: "lat", name: "startLat", checkbox: false},
  {uid: "lng", name: "startLng ", checkbox: false}
];
export const ViewOutputData = function ({
  exportData,
  selectedOption
}: {
  exportData: rpExportData | undefined;
  selectedOption: any;
}) {
  const [viewExportData, setViewExportData] = useState<any>([]);
  useEffect(() => {
    const tableConfigdatas = {
      ...tableConfig,
      columns: selectedOption === "option1" ? unmappedColumns : mappedColumns,
      meta: {
        ...tableConfig.meta,
        title: selectedOption === "option1" ? "Unmapped Users" : "Mapped Users"
      },
      tabledatas:
        selectedOption === "option1"
          ? exportData?.unMappedUsers
          : exportData?.mappedUsers
    };
    setViewExportData(tableConfigdatas);
  }, [exportData]);
  return <>{viewExportData?.columns && <NeoAGgrid table={viewExportData} />}</>;
};
